module.exports = __webpack_public_path__ + "static/img/gengduo.4f3bd88c.png";